// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ClaimEntitlementRequest
 */
export interface ClaimEntitlementRequest {
  /**
   * billing account ID to claim the entitlement
   * @type {string}
   * @memberof ClaimEntitlementRequest
   */
  billingAccountID: string;
}

/**
 * Check if a given object implements the ClaimEntitlementRequest interface.
 */
export function instanceOfClaimEntitlementRequest(
  value: object,
): value is ClaimEntitlementRequest {
  if (!('billingAccountID' in value) || value['billingAccountID'] === undefined)
    return false;
  return true;
}

export function ClaimEntitlementRequestFromJSON(
  json: any,
): ClaimEntitlementRequest {
  return ClaimEntitlementRequestFromJSONTyped(json, false);
}

export function ClaimEntitlementRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ClaimEntitlementRequest {
  if (json == null) {
    return json;
  }
  return {
    billingAccountID: json['billingAccountID'],
  };
}

export function ClaimEntitlementRequestToJSON(
  json: any,
): ClaimEntitlementRequest {
  return ClaimEntitlementRequestToJSONTyped(json, false);
}

export function ClaimEntitlementRequestToJSONTyped(
  value?: ClaimEntitlementRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    billingAccountID: value['billingAccountID'],
  };
}
